import { globalEnv } from "~/global-env";
import { type TicketStatus } from "~/graphql/supergraphTypes";

export const TICKET_STATUS_DISPLAY_MAP: Record<TicketStatus, string> = {
  IN_PROGRESS: "In Progress",
  DONE: "Done",
  TO_DO: "To Do",
  INDEXING: "Indexing",
  PENDING_CLIENT: "Pending Client",
  BLOCKED: "Blocked",
  COMPLETE: "Complete",
  IN_REVIEW: "In Review",
  WILL_NOT_DO: "Will Not Do",
  MAKER: "Maker",
  CHECKER: "Checker",
  INCOMPLETE: "Incomplete",
};

export const COMMENT_ERROR_TOAST_ID = "workflow-comment-adf-to-html-conversion-error";

export const JIRA_PROJECT_KEY = "FA";

export const TICKETS_TABLE_PAGE_SIZE = 20;

export const MAX_VISIBLE_CHIPS = 2;

export const UNASSIGNED_FILTER_VALUE = "Unassigned";

export const FIELDS_REQUIRING_UNASSIGNED_OPTION = [
  "customers",
  "entityName",
  "assignedTo",
  "faPreparer",
  "faReviewer",
  "isPrimary",
  "isReviewer",
] as const;

export const URL_PARAMS = {
  FILTERS_PARAM: "filters",
  SORTS_PARAM: "sorts",
} as const;

export const URL_FILTER_FIELDS = {
  // Legacy Jira grid field names
  ASSIGNEE_ID: "assigneeId",
  ARENA_NAME: "customers",
  ASSIGNED_TO: "assignedTo",
  WORKFLOW_TYPE: "workType",
  // WorkflowEngine (crltWorkflowEngine=ON) field names
  // Must match the `field` value on the AG Grid column defs in WorkflowTable
  // (jsq-control-tower-components) — these are also what getWorkflowFilterVars
  // reads from params.request.filterModel to build the GraphQL variables.
  CLIENT_NAME: "clientName", // → clientIds
  ASSIGNEE: "assignee", // → assignedToUserIds
  WORKFLOW_TYPE_WE: "workflowType", // → workflowTypes
  // Shared across both engines
  STATUS: "status",
  DUE_DATE: "dueDate",
} as const;

export const WORKFLOWS_ROUTE = `${globalEnv.controlTowerRoute}/workflows`;
